import {
    assistantAsking, assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";


export const generatePlotLinePrompt = (vars: {
    lineNumber: number,
    genres: string[],
    synopsis: string,
    otherLines?: { line: number, title: string, content: string }[] | undefined,
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения с несколькими сюжетными линиями"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Укажи содержимое других сюжетных линий", vars.otherLines ? JSON.stringify(vars.otherLines) : undefined))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй содержимое других сюжетных линий",
        "Сгенерируй содержимое сюжетной линии",
        "Обязательно добавь концовку сюжетной линии",
        "Каждая концовка должна быть уникальной"
    ]))
    .concat(assistantAskingForRequirements([
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Главный герой встречает свою вторую половинку",
            description: "Герой преодолев все трудности сумел найти свою вторую половинку"
        }
    }))
    .concat(assistantAskingForAction(`Сгенерируй ${vars.lineNumber}-ю сюжетную линию.`))